import Financial, { FinancialSections } from './Financial';

export default Financial;
export { FinancialSections };
